module.exports = __webpack_public_path__ + "static/media/report2.f0c676e6.svg";